// Dependencies
import React, { FunctionComponent } from 'react'

// Styles
import {
  ChatMessageBoxContainer,
  ChatMessageBoxContainerMessagesWrapper,
  ChatMessageItemContainer,
  ChatMessageItemLabel,
  Container
} from './chat.styles'

// Types
import {
  ChatProps,
  ChatMessageBoxProps,
  ChatMessageItemProps
} from './chat.types'

export const Chat: FunctionComponent<ChatProps> = ({
  content,
  closeIconElement
}) => {
  return (
    <Container>
      <div className="close-icon">{closeIconElement}</div>

      {content}
    </Container>
  )
}

export const ChatMessageBox: FunctionComponent<ChatMessageBoxProps> = ({
  headerComposition,
  messagesComposition
}) => {
  return (
    <ChatMessageBoxContainer>
      <div>{headerComposition}</div>

      <ChatMessageBoxContainerMessagesWrapper>
        {messagesComposition}
      </ChatMessageBoxContainerMessagesWrapper>
    </ChatMessageBoxContainer>
  )
}

export const ChatMessageItem: FunctionComponent<ChatMessageItemProps> = ({
  isActive,
  label,
  type,
  handleClick
}) => {
  return (
    <ChatMessageItemContainer
      className="chat-message-item"
      type={type}
      isActive={!!isActive}
      onClick={handleClick}
    >
      <ChatMessageItemLabel>{label}</ChatMessageItemLabel>
    </ChatMessageItemContainer>
  )
}
